import { render } from "./CreateDomain.vue?vue&type=template&id=d2066878&ts=true"
import script from "./CreateDomain.vue?vue&type=script&lang=ts"
export * from "./CreateDomain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__